import styled from "styled-components";
import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   width: 10px;
   height: 10px;
   background-color: black;
   border-radius: 50%;
   ${({ css }) => css}
`;

export default function Circle(props: Types.Default) {
   return <Wrap {...props}></Wrap>;
}
